/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AnalyzeSectionSimilarity200,
  AnalyzeSectionSimilarityBody,
  BadRequestResponse,
  Chat,
  ConflictResponse,
  CreateCategoryFromCategory200,
  CreateCategoryFromCategoryBody,
  CreateCategoryFromItem200,
  CreateCategoryFromItemBody,
  CreateCategoryFromSections200,
  CreateCategoryFromSectionsBody,
  CreateChatBody,
  CreateChatParams,
  CreateSectionFromPage200,
  CreateSectionFromPageBody,
  DeleteDoclistCategory200,
  DeleteDoclistCategoryBody,
  DeleteDoclistSection200,
  DeleteDoclistSectionBody,
  DeleteDoclistSections200,
  DeleteDoclistSectionsBody,
  DeleteSectionPage200,
  DeleteSectionPageBody,
  ExportAsyncChatDoclist202,
  ExportAsyncChatDoclistBody,
  ExportDoclist200,
  ExportDoclistBody,
  ForbiddenResponse,
  GetChatQuestions200,
  GetDoclist200,
  GetDoclistParams,
  GetSummary200,
  GetSummaryParams,
  GetTerms200,
  GetUniversalSummary200,
  GetUniversalSummary404,
  GetUniversalSummaryBody,
  InternalServerErrorResponse,
  MergeAllCategorySections200,
  MergeAllCategorySectionsBody,
  MergeChatDoclistSections200,
  MergeChatDoclistSectionsBody,
  MergeSectionsMultiple200,
  MergeSectionsMultipleBody,
  NotFoundResponse,
  PopulateBulkDoclistPages202,
  PopulateBulkDoclistPagesBody,
  RecreateChat201,
  RecreateChatBody,
  RegenerateSectionTitle200,
  RegenerateSectionTitleBody,
  RegenerateSectionTitlesMultiple200,
  RegenerateSectionTitlesMultipleBody,
  RenameDoclistCategory200,
  RenameDoclistCategoryBody,
  RenameDoclistSection200,
  RenameDoclistSectionBody,
  ReorderChatDoclistCategories200,
  ReorderChatDoclistCategories400,
  ReorderChatDoclistCategoriesBody,
  ReorderChatDoclistPages200,
  ReorderChatDoclistPagesBody,
  ReorderChatDoclistSections200,
  ReorderChatDoclistSections400,
  ReorderChatDoclistSectionsBody,
  ReorderSectionsMultiple200,
  ReorderSectionsMultiple400,
  ReorderSectionsMultipleBody,
  RestoreSectionPage200,
  RotateSectionPage200,
  RotateSectionPageBody,
  SortCategorySections200,
  SortCategorySectionsBody,
  SplitDoclistSection200,
  SplitDoclistSectionBody,
  StreamChatMessageBody,
  UnauthorizedResponse
} from '.././model'
import { customInstance } from '../../custom-instance';


// eslint-disable-next-line
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;


/**
 * @summary Create a new chat for a collection of documents
 */
export const createChat = (
    organizationId: string,
    projectId: string,
    createChatBody: CreateChatBody,
    params?: CreateChatParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Chat>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: createChatBody,
        params
    },
      options);
    }
  


export const getCreateChatMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChat>>, TError,{organizationId: string;projectId: string;data: CreateChatBody;params?: CreateChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createChat>>, TError,{organizationId: string;projectId: string;data: CreateChatBody;params?: CreateChatParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChat>>, {organizationId: string;projectId: string;data: CreateChatBody;params?: CreateChatParams}> = (props) => {
          const {organizationId,projectId,data,params} = props ?? {};

          return  createChat(organizationId,projectId,data,params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateChatMutationResult = NonNullable<Awaited<ReturnType<typeof createChat>>>
    export type CreateChatMutationBody = CreateChatBody
    export type CreateChatMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Create a new chat for a collection of documents
 */
export const useCreateChat = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChat>>, TError,{organizationId: string;projectId: string;data: CreateChatBody;params?: CreateChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getCreateChatMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get chat
 */
export const getChat = (
    organizationId: string,
    projectId: string,
    chatId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Chat>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}`, method: 'get', signal
    },
      options);
    }
  

export const getGetChatQueryKey = (organizationId: string,
    projectId: string,
    chatId: string,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}`] as const;
    }

    
export const getGetChatQueryOptions = <TData = Awaited<ReturnType<typeof getChat>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    chatId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatQueryKey(organizationId,projectId,chatId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChat>>> = ({ signal }) => getChat(organizationId,projectId,chatId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && projectId && chatId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData> & { queryKey: QueryKey }
}

export type GetChatQueryResult = NonNullable<Awaited<ReturnType<typeof getChat>>>
export type GetChatQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Get chat
 */
export const useGetChat = <TData = Awaited<ReturnType<typeof getChat>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    chatId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetChatQueryOptions(organizationId,projectId,chatId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * Sends a message to the chat and streams the AI response using Server-Sent Events (SSE).
The response is streamed as a series of events including message_start, delta, and message_end.

 * @summary Stream a chat message using SSE
 */
export const streamChatMessage = (
    organizationId: string,
    projectId: string,
    chatId: string,
    streamChatMessageBody: StreamChatMessageBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<string>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/stream`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: streamChatMessageBody
    },
      options);
    }
  


export const getStreamChatMessageMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof streamChatMessage>>, TError,{organizationId: string;projectId: string;chatId: string;data: StreamChatMessageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof streamChatMessage>>, TError,{organizationId: string;projectId: string;chatId: string;data: StreamChatMessageBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof streamChatMessage>>, {organizationId: string;projectId: string;chatId: string;data: StreamChatMessageBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  streamChatMessage(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type StreamChatMessageMutationResult = NonNullable<Awaited<ReturnType<typeof streamChatMessage>>>
    export type StreamChatMessageMutationBody = StreamChatMessageBody
    export type StreamChatMessageMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Stream a chat message using SSE
 */
export const useStreamChatMessage = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof streamChatMessage>>, TError,{organizationId: string;projectId: string;chatId: string;data: StreamChatMessageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getStreamChatMessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get project summary or snapshot
 */
export const getSummary = (
    organizationId: string,
    projectId: string,
    chatId: string,
    params?: GetSummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSummary200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/summary`, method: 'get',
        params, signal
    },
      options);
    }
  

export const getGetSummaryQueryKey = (organizationId: string,
    projectId: string,
    chatId: string,
    params?: GetSummaryParams,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/summary`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getSummary>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    chatId: string,
    params?: GetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSummaryQueryKey(organizationId,projectId,chatId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSummary>>> = ({ signal }) => getSummary(organizationId,projectId,chatId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && projectId && chatId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSummary>>>
export type GetSummaryQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Get project summary or snapshot
 */
export const useGetSummary = <TData = Awaited<ReturnType<typeof getSummary>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    chatId: string,
    params?: GetSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSummaryQueryOptions(organizationId,projectId,chatId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get combined terms from summary and snapshot
 */
export const getTerms = (
    organizationId: string,
    projectId: string,
    chatId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetTerms200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/terms`, method: 'get', signal
    },
      options);
    }
  

export const getGetTermsQueryKey = (organizationId: string,
    projectId: string,
    chatId: string,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/terms`] as const;
    }

    
export const getGetTermsQueryOptions = <TData = Awaited<ReturnType<typeof getTerms>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    chatId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTermsQueryKey(organizationId,projectId,chatId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTerms>>> = ({ signal }) => getTerms(organizationId,projectId,chatId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && projectId && chatId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTermsQueryResult = NonNullable<Awaited<ReturnType<typeof getTerms>>>
export type GetTermsQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Get combined terms from summary and snapshot
 */
export const useGetTerms = <TData = Awaited<ReturnType<typeof getTerms>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    chatId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTermsQueryOptions(organizationId,projectId,chatId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get doclist for a chat
 */
export const getDoclist = (
    organizationId: string,
    projectId: string,
    params?: GetDoclistParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetDoclist200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist`, method: 'get',
        params, signal
    },
      options);
    }
  

export const getGetDoclistQueryKey = (organizationId: string,
    projectId: string,
    params?: GetDoclistParams,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDoclistQueryOptions = <TData = Awaited<ReturnType<typeof getDoclist>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    params?: GetDoclistParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoclist>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDoclistQueryKey(organizationId,projectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDoclist>>> = ({ signal }) => getDoclist(organizationId,projectId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDoclist>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDoclistQueryResult = NonNullable<Awaited<ReturnType<typeof getDoclist>>>
export type GetDoclistQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Get doclist for a chat
 */
export const useGetDoclist = <TData = Awaited<ReturnType<typeof getDoclist>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    params?: GetDoclistParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoclist>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDoclistQueryOptions(organizationId,projectId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Export doclist to a document format
 */
export const exportDoclist = (
    organizationId: string,
    projectId: string,
    chatId: string,
    exportDoclistBody: ExportDoclistBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ExportDoclist200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/export`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: exportDoclistBody
    },
      options);
    }
  


export const getExportDoclistMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportDoclist>>, TError,{organizationId: string;projectId: string;chatId: string;data: ExportDoclistBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof exportDoclist>>, TError,{organizationId: string;projectId: string;chatId: string;data: ExportDoclistBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportDoclist>>, {organizationId: string;projectId: string;chatId: string;data: ExportDoclistBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  exportDoclist(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ExportDoclistMutationResult = NonNullable<Awaited<ReturnType<typeof exportDoclist>>>
    export type ExportDoclistMutationBody = ExportDoclistBody
    export type ExportDoclistMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Export doclist to a document format
 */
export const useExportDoclist = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportDoclist>>, TError,{organizationId: string;projectId: string;chatId: string;data: ExportDoclistBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getExportDoclistMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get suggested questions for the chat
 */
export const getChatQuestions = (
    organizationId: string,
    projectId: string,
    chatId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetChatQuestions200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/questions`, method: 'get', signal
    },
      options);
    }
  

export const getGetChatQuestionsQueryKey = (organizationId: string,
    projectId: string,
    chatId: string,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/questions`] as const;
    }

    
export const getGetChatQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof getChatQuestions>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    chatId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatQuestions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatQuestionsQueryKey(organizationId,projectId,chatId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatQuestions>>> = ({ signal }) => getChatQuestions(organizationId,projectId,chatId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && projectId && chatId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatQuestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetChatQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getChatQuestions>>>
export type GetChatQuestionsQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Get suggested questions for the chat
 */
export const useGetChatQuestions = <TData = Awaited<ReturnType<typeof getChatQuestions>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    chatId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatQuestions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetChatQuestionsQueryOptions(organizationId,projectId,chatId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Reorder sections in a chat's doclist
 */
export const reorderChatDoclistSections = (
    organizationId: string,
    projectId: string,
    reorderChatDoclistSectionsBody: ReorderChatDoclistSectionsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ReorderChatDoclistSections200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/sections/reorder`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: reorderChatDoclistSectionsBody
    },
      options);
    }
  


export const getReorderChatDoclistSectionsMutationOptions = <TError = ReorderChatDoclistSections400 | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderChatDoclistSections>>, TError,{organizationId: string;projectId: string;data: ReorderChatDoclistSectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderChatDoclistSections>>, TError,{organizationId: string;projectId: string;data: ReorderChatDoclistSectionsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderChatDoclistSections>>, {organizationId: string;projectId: string;data: ReorderChatDoclistSectionsBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  reorderChatDoclistSections(organizationId,projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ReorderChatDoclistSectionsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderChatDoclistSections>>>
    export type ReorderChatDoclistSectionsMutationBody = ReorderChatDoclistSectionsBody
    export type ReorderChatDoclistSectionsMutationError = ReorderChatDoclistSections400 | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Reorder sections in a chat's doclist
 */
export const useReorderChatDoclistSections = <TError = ReorderChatDoclistSections400 | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderChatDoclistSections>>, TError,{organizationId: string;projectId: string;data: ReorderChatDoclistSectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getReorderChatDoclistSectionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Reorder multiple sections in a chat's doclist
 */
export const reorderSectionsMultiple = (
    organizationId: string,
    projectId: string,
    reorderSectionsMultipleBody: ReorderSectionsMultipleBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ReorderSectionsMultiple200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/sections/reorder/multiple`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: reorderSectionsMultipleBody
    },
      options);
    }
  


export const getReorderSectionsMultipleMutationOptions = <TError = ReorderSectionsMultiple400 | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderSectionsMultiple>>, TError,{organizationId: string;projectId: string;data: ReorderSectionsMultipleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderSectionsMultiple>>, TError,{organizationId: string;projectId: string;data: ReorderSectionsMultipleBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderSectionsMultiple>>, {organizationId: string;projectId: string;data: ReorderSectionsMultipleBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  reorderSectionsMultiple(organizationId,projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ReorderSectionsMultipleMutationResult = NonNullable<Awaited<ReturnType<typeof reorderSectionsMultiple>>>
    export type ReorderSectionsMultipleMutationBody = ReorderSectionsMultipleBody
    export type ReorderSectionsMultipleMutationError = ReorderSectionsMultiple400 | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Reorder multiple sections in a chat's doclist
 */
export const useReorderSectionsMultiple = <TError = ReorderSectionsMultiple400 | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderSectionsMultiple>>, TError,{organizationId: string;projectId: string;data: ReorderSectionsMultipleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getReorderSectionsMultipleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Reorder categories in a chat's doclist
 */
export const reorderChatDoclistCategories = (
    organizationId: string,
    projectId: string,
    reorderChatDoclistCategoriesBody: ReorderChatDoclistCategoriesBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ReorderChatDoclistCategories200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/reorder`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: reorderChatDoclistCategoriesBody
    },
      options);
    }
  


export const getReorderChatDoclistCategoriesMutationOptions = <TError = ReorderChatDoclistCategories400 | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderChatDoclistCategories>>, TError,{organizationId: string;projectId: string;data: ReorderChatDoclistCategoriesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderChatDoclistCategories>>, TError,{organizationId: string;projectId: string;data: ReorderChatDoclistCategoriesBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderChatDoclistCategories>>, {organizationId: string;projectId: string;data: ReorderChatDoclistCategoriesBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  reorderChatDoclistCategories(organizationId,projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ReorderChatDoclistCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof reorderChatDoclistCategories>>>
    export type ReorderChatDoclistCategoriesMutationBody = ReorderChatDoclistCategoriesBody
    export type ReorderChatDoclistCategoriesMutationError = ReorderChatDoclistCategories400 | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Reorder categories in a chat's doclist
 */
export const useReorderChatDoclistCategories = <TError = ReorderChatDoclistCategories400 | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderChatDoclistCategories>>, TError,{organizationId: string;projectId: string;data: ReorderChatDoclistCategoriesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getReorderChatDoclistCategoriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Reorder pages in a chat's doclist
 */
export const reorderChatDoclistPages = (
    organizationId: string,
    projectId: string,
    chatId: string,
    reorderChatDoclistPagesBody: ReorderChatDoclistPagesBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ReorderChatDoclistPages200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/pages/reorder`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: reorderChatDoclistPagesBody
    },
      options);
    }
  


export const getReorderChatDoclistPagesMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderChatDoclistPages>>, TError,{organizationId: string;projectId: string;chatId: string;data: ReorderChatDoclistPagesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderChatDoclistPages>>, TError,{organizationId: string;projectId: string;chatId: string;data: ReorderChatDoclistPagesBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderChatDoclistPages>>, {organizationId: string;projectId: string;chatId: string;data: ReorderChatDoclistPagesBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  reorderChatDoclistPages(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ReorderChatDoclistPagesMutationResult = NonNullable<Awaited<ReturnType<typeof reorderChatDoclistPages>>>
    export type ReorderChatDoclistPagesMutationBody = ReorderChatDoclistPagesBody
    export type ReorderChatDoclistPagesMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Reorder pages in a chat's doclist
 */
export const useReorderChatDoclistPages = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderChatDoclistPages>>, TError,{organizationId: string;projectId: string;chatId: string;data: ReorderChatDoclistPagesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getReorderChatDoclistPagesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Recreate a chat from an existing chat
 */
export const recreateChat = (
    organizationId: string,
    projectId: string,
    recreateChatBody: RecreateChatBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RecreateChat201>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/recreate`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: recreateChatBody
    },
      options);
    }
  


export const getRecreateChatMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recreateChat>>, TError,{organizationId: string;projectId: string;data: RecreateChatBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recreateChat>>, TError,{organizationId: string;projectId: string;data: RecreateChatBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recreateChat>>, {organizationId: string;projectId: string;data: RecreateChatBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  recreateChat(organizationId,projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RecreateChatMutationResult = NonNullable<Awaited<ReturnType<typeof recreateChat>>>
    export type RecreateChatMutationBody = RecreateChatBody
    export type RecreateChatMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Recreate a chat from an existing chat
 */
export const useRecreateChat = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recreateChat>>, TError,{organizationId: string;projectId: string;data: RecreateChatBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getRecreateChatMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Asynchronously export doclist to a document format
 */
export const exportAsyncChatDoclist = (
    organizationId: string,
    projectId: string,
    chatId: string,
    exportAsyncChatDoclistBody: ExportAsyncChatDoclistBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ExportAsyncChatDoclist202>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/export/async`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: exportAsyncChatDoclistBody
    },
      options);
    }
  


export const getExportAsyncChatDoclistMutationOptions = <TError = unknown,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportAsyncChatDoclist>>, TError,{organizationId: string;projectId: string;chatId: string;data: ExportAsyncChatDoclistBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof exportAsyncChatDoclist>>, TError,{organizationId: string;projectId: string;chatId: string;data: ExportAsyncChatDoclistBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportAsyncChatDoclist>>, {organizationId: string;projectId: string;chatId: string;data: ExportAsyncChatDoclistBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  exportAsyncChatDoclist(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ExportAsyncChatDoclistMutationResult = NonNullable<Awaited<ReturnType<typeof exportAsyncChatDoclist>>>
    export type ExportAsyncChatDoclistMutationBody = ExportAsyncChatDoclistBody
    export type ExportAsyncChatDoclistMutationError = unknown

    /**
 * @summary Asynchronously export doclist to a document format
 */
export const useExportAsyncChatDoclist = <TError = unknown,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportAsyncChatDoclist>>, TError,{organizationId: string;projectId: string;chatId: string;data: ExportAsyncChatDoclistBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getExportAsyncChatDoclistMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Rotate a section page
 */
export const rotateSectionPage = (
    organizationId: string,
    projectId: string,
    sectionId: string,
    pageId: string,
    rotateSectionPageBody: RotateSectionPageBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RotateSectionPage200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/sections/${sectionId}/pages/${pageId}/rotate`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: rotateSectionPageBody
    },
      options);
    }
  


export const getRotateSectionPageMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateSectionPage>>, TError,{organizationId: string;projectId: string;sectionId: string;pageId: string;data: RotateSectionPageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rotateSectionPage>>, TError,{organizationId: string;projectId: string;sectionId: string;pageId: string;data: RotateSectionPageBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateSectionPage>>, {organizationId: string;projectId: string;sectionId: string;pageId: string;data: RotateSectionPageBody}> = (props) => {
          const {organizationId,projectId,sectionId,pageId,data} = props ?? {};

          return  rotateSectionPage(organizationId,projectId,sectionId,pageId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RotateSectionPageMutationResult = NonNullable<Awaited<ReturnType<typeof rotateSectionPage>>>
    export type RotateSectionPageMutationBody = RotateSectionPageBody
    export type RotateSectionPageMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Rotate a section page
 */
export const useRotateSectionPage = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateSectionPage>>, TError,{organizationId: string;projectId: string;sectionId: string;pageId: string;data: RotateSectionPageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getRotateSectionPageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Mark a section page as deleted
 */
export const deleteSectionPage = (
    organizationId: string,
    projectId: string,
    chatId: string,
    sectionId: string,
    pageId: string,
    deleteSectionPageBody: DeleteSectionPageBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteSectionPage200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/sections/${sectionId}/pages/${pageId}`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: deleteSectionPageBody
    },
      options);
    }
  


export const getDeleteSectionPageMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSectionPage>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;pageId: string;data: DeleteSectionPageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSectionPage>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;pageId: string;data: DeleteSectionPageBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSectionPage>>, {organizationId: string;projectId: string;chatId: string;sectionId: string;pageId: string;data: DeleteSectionPageBody}> = (props) => {
          const {organizationId,projectId,chatId,sectionId,pageId,data} = props ?? {};

          return  deleteSectionPage(organizationId,projectId,chatId,sectionId,pageId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteSectionPageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSectionPage>>>
    export type DeleteSectionPageMutationBody = DeleteSectionPageBody
    export type DeleteSectionPageMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Mark a section page as deleted
 */
export const useDeleteSectionPage = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSectionPage>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;pageId: string;data: DeleteSectionPageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getDeleteSectionPageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Restore a deleted section page
 */
export const restoreSectionPage = (
    organizationId: string,
    projectId: string,
    chatId: string,
    sectionId: string,
    pageId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RestoreSectionPage200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/sections/${sectionId}/pages/${pageId}/restore`, method: 'post'
    },
      options);
    }
  


export const getRestoreSectionPageMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreSectionPage>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;pageId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreSectionPage>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;pageId: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreSectionPage>>, {organizationId: string;projectId: string;chatId: string;sectionId: string;pageId: string}> = (props) => {
          const {organizationId,projectId,chatId,sectionId,pageId} = props ?? {};

          return  restoreSectionPage(organizationId,projectId,chatId,sectionId,pageId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RestoreSectionPageMutationResult = NonNullable<Awaited<ReturnType<typeof restoreSectionPage>>>
    
    export type RestoreSectionPageMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Restore a deleted section page
 */
export const useRestoreSectionPage = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreSectionPage>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;pageId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getRestoreSectionPageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Mark all section pages as deleted
 */
export const deleteDoclistSection = (
    organizationId: string,
    projectId: string,
    chatId: string,
    sectionId: string,
    deleteDoclistSectionBody: DeleteDoclistSectionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteDoclistSection200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/${sectionId}/delete`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: deleteDoclistSectionBody
    },
      options);
    }
  


export const getDeleteDoclistSectionMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDoclistSection>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;data: DeleteDoclistSectionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDoclistSection>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;data: DeleteDoclistSectionBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDoclistSection>>, {organizationId: string;projectId: string;chatId: string;sectionId: string;data: DeleteDoclistSectionBody}> = (props) => {
          const {organizationId,projectId,chatId,sectionId,data} = props ?? {};

          return  deleteDoclistSection(organizationId,projectId,chatId,sectionId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteDoclistSectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDoclistSection>>>
    export type DeleteDoclistSectionMutationBody = DeleteDoclistSectionBody
    export type DeleteDoclistSectionMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Mark all section pages as deleted
 */
export const useDeleteDoclistSection = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDoclistSection>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;data: DeleteDoclistSectionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getDeleteDoclistSectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Mark all section pages as deleted for multiple sections
 */
export const deleteDoclistSections = (
    organizationId: string,
    projectId: string,
    chatId: string,
    deleteDoclistSectionsBody: DeleteDoclistSectionsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteDoclistSections200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/delete`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: deleteDoclistSectionsBody
    },
      options);
    }
  


export const getDeleteDoclistSectionsMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDoclistSections>>, TError,{organizationId: string;projectId: string;chatId: string;data: DeleteDoclistSectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDoclistSections>>, TError,{organizationId: string;projectId: string;chatId: string;data: DeleteDoclistSectionsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDoclistSections>>, {organizationId: string;projectId: string;chatId: string;data: DeleteDoclistSectionsBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  deleteDoclistSections(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteDoclistSectionsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDoclistSections>>>
    export type DeleteDoclistSectionsMutationBody = DeleteDoclistSectionsBody
    export type DeleteDoclistSectionsMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Mark all section pages as deleted for multiple sections
 */
export const useDeleteDoclistSections = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDoclistSections>>, TError,{organizationId: string;projectId: string;chatId: string;data: DeleteDoclistSectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getDeleteDoclistSectionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Populate URLs for multiple doclist pages
 */
export const populateBulkDoclistPages = (
    organizationId: string,
    projectId: string,
    chatId: string,
    populateBulkDoclistPagesBody: PopulateBulkDoclistPagesBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PopulateBulkDoclistPages202>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/pages`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: populateBulkDoclistPagesBody
    },
      options);
    }
  


export const getPopulateBulkDoclistPagesMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof populateBulkDoclistPages>>, TError,{organizationId: string;projectId: string;chatId: string;data: PopulateBulkDoclistPagesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof populateBulkDoclistPages>>, TError,{organizationId: string;projectId: string;chatId: string;data: PopulateBulkDoclistPagesBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof populateBulkDoclistPages>>, {organizationId: string;projectId: string;chatId: string;data: PopulateBulkDoclistPagesBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  populateBulkDoclistPages(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PopulateBulkDoclistPagesMutationResult = NonNullable<Awaited<ReturnType<typeof populateBulkDoclistPages>>>
    export type PopulateBulkDoclistPagesMutationBody = PopulateBulkDoclistPagesBody
    export type PopulateBulkDoclistPagesMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Populate URLs for multiple doclist pages
 */
export const usePopulateBulkDoclistPages = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof populateBulkDoclistPages>>, TError,{organizationId: string;projectId: string;chatId: string;data: PopulateBulkDoclistPagesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getPopulateBulkDoclistPagesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Creates a new section from an existing page
 */
export const createSectionFromPage = (
    organizationId: string,
    projectId: string,
    chatId: string,
    createSectionFromPageBody: CreateSectionFromPageBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateSectionFromPage200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/create`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: createSectionFromPageBody
    },
      options);
    }
  


export const getCreateSectionFromPageMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSectionFromPage>>, TError,{organizationId: string;projectId: string;chatId: string;data: CreateSectionFromPageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSectionFromPage>>, TError,{organizationId: string;projectId: string;chatId: string;data: CreateSectionFromPageBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSectionFromPage>>, {organizationId: string;projectId: string;chatId: string;data: CreateSectionFromPageBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  createSectionFromPage(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateSectionFromPageMutationResult = NonNullable<Awaited<ReturnType<typeof createSectionFromPage>>>
    export type CreateSectionFromPageMutationBody = CreateSectionFromPageBody
    export type CreateSectionFromPageMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Creates a new section from an existing page
 */
export const useCreateSectionFromPage = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSectionFromPage>>, TError,{organizationId: string;projectId: string;chatId: string;data: CreateSectionFromPageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getCreateSectionFromPageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Rename a doclist section
 */
export const renameDoclistSection = (
    organizationId: string,
    projectId: string,
    chatId: string,
    sectionId: string,
    renameDoclistSectionBody: RenameDoclistSectionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RenameDoclistSection200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/${sectionId}/rename`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: renameDoclistSectionBody
    },
      options);
    }
  


export const getRenameDoclistSectionMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameDoclistSection>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;data: RenameDoclistSectionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof renameDoclistSection>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;data: RenameDoclistSectionBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameDoclistSection>>, {organizationId: string;projectId: string;chatId: string;sectionId: string;data: RenameDoclistSectionBody}> = (props) => {
          const {organizationId,projectId,chatId,sectionId,data} = props ?? {};

          return  renameDoclistSection(organizationId,projectId,chatId,sectionId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RenameDoclistSectionMutationResult = NonNullable<Awaited<ReturnType<typeof renameDoclistSection>>>
    export type RenameDoclistSectionMutationBody = RenameDoclistSectionBody
    export type RenameDoclistSectionMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Rename a doclist section
 */
export const useRenameDoclistSection = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameDoclistSection>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;data: RenameDoclistSectionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getRenameDoclistSectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Triggers the section-title lambda to regenerate the title based on the section's current content
 * @summary Regenerate AI-generated title for a section
 */
export const regenerateSectionTitle = (
    organizationId: string,
    projectId: string,
    chatId: string,
    sectionId: string,
    regenerateSectionTitleBody: RegenerateSectionTitleBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RegenerateSectionTitle200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/${sectionId}/regenerate-title`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: regenerateSectionTitleBody
    },
      options);
    }
  


export const getRegenerateSectionTitleMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateSectionTitle>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;data: RegenerateSectionTitleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateSectionTitle>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;data: RegenerateSectionTitleBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateSectionTitle>>, {organizationId: string;projectId: string;chatId: string;sectionId: string;data: RegenerateSectionTitleBody}> = (props) => {
          const {organizationId,projectId,chatId,sectionId,data} = props ?? {};

          return  regenerateSectionTitle(organizationId,projectId,chatId,sectionId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RegenerateSectionTitleMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateSectionTitle>>>
    export type RegenerateSectionTitleMutationBody = RegenerateSectionTitleBody
    export type RegenerateSectionTitleMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Regenerate AI-generated title for a section
 */
export const useRegenerateSectionTitle = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateSectionTitle>>, TError,{organizationId: string;projectId: string;chatId: string;sectionId: string;data: RegenerateSectionTitleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getRegenerateSectionTitleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Triggers parallel AI title generation for multiple sections, significantly faster than calling regenerateSectionTitle sequentially
 * @summary Regenerate AI-generated titles for multiple sections in parallel
 */
export const regenerateSectionTitlesMultiple = (
    organizationId: string,
    projectId: string,
    chatId: string,
    regenerateSectionTitlesMultipleBody: RegenerateSectionTitlesMultipleBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RegenerateSectionTitlesMultiple200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/regenerate-titles`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: regenerateSectionTitlesMultipleBody
    },
      options);
    }
  


export const getRegenerateSectionTitlesMultipleMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>, TError,{organizationId: string;projectId: string;chatId: string;data: RegenerateSectionTitlesMultipleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>, TError,{organizationId: string;projectId: string;chatId: string;data: RegenerateSectionTitlesMultipleBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>, {organizationId: string;projectId: string;chatId: string;data: RegenerateSectionTitlesMultipleBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  regenerateSectionTitlesMultiple(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RegenerateSectionTitlesMultipleMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>>
    export type RegenerateSectionTitlesMultipleMutationBody = RegenerateSectionTitlesMultipleBody
    export type RegenerateSectionTitlesMultipleMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Regenerate AI-generated titles for multiple sections in parallel
 */
export const useRegenerateSectionTitlesMultiple = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>, TError,{organizationId: string;projectId: string;chatId: string;data: RegenerateSectionTitlesMultipleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getRegenerateSectionTitlesMultipleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Rename a doclist category
 */
export const renameDoclistCategory = (
    organizationId: string,
    projectId: string,
    categoryId: number,
    renameDoclistCategoryBody: RenameDoclistCategoryBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RenameDoclistCategory200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/${categoryId}/rename`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: renameDoclistCategoryBody
    },
      options);
    }
  


export const getRenameDoclistCategoryMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameDoclistCategory>>, TError,{organizationId: string;projectId: string;categoryId: number;data: RenameDoclistCategoryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof renameDoclistCategory>>, TError,{organizationId: string;projectId: string;categoryId: number;data: RenameDoclistCategoryBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameDoclistCategory>>, {organizationId: string;projectId: string;categoryId: number;data: RenameDoclistCategoryBody}> = (props) => {
          const {organizationId,projectId,categoryId,data} = props ?? {};

          return  renameDoclistCategory(organizationId,projectId,categoryId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RenameDoclistCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof renameDoclistCategory>>>
    export type RenameDoclistCategoryMutationBody = RenameDoclistCategoryBody
    export type RenameDoclistCategoryMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Rename a doclist category
 */
export const useRenameDoclistCategory = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameDoclistCategory>>, TError,{organizationId: string;projectId: string;categoryId: number;data: RenameDoclistCategoryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getRenameDoclistCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Creates a new category from an existing section or page
 */
export const createCategoryFromItem = (
    organizationId: string,
    projectId: string,
    createCategoryFromItemBody: CreateCategoryFromItemBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateCategoryFromItem200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/create`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: createCategoryFromItemBody
    },
      options);
    }
  


export const getCreateCategoryFromItemMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategoryFromItem>>, TError,{organizationId: string;projectId: string;data: CreateCategoryFromItemBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCategoryFromItem>>, TError,{organizationId: string;projectId: string;data: CreateCategoryFromItemBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCategoryFromItem>>, {organizationId: string;projectId: string;data: CreateCategoryFromItemBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  createCategoryFromItem(organizationId,projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateCategoryFromItemMutationResult = NonNullable<Awaited<ReturnType<typeof createCategoryFromItem>>>
    export type CreateCategoryFromItemMutationBody = CreateCategoryFromItemBody
    export type CreateCategoryFromItemMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Creates a new category from an existing section or page
 */
export const useCreateCategoryFromItem = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategoryFromItem>>, TError,{organizationId: string;projectId: string;data: CreateCategoryFromItemBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getCreateCategoryFromItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Creates a new category from existing sections
 */
export const createCategoryFromSections = (
    organizationId: string,
    projectId: string,
    createCategoryFromSectionsBody: CreateCategoryFromSectionsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateCategoryFromSections200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/create/multiple`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: createCategoryFromSectionsBody
    },
      options);
    }
  


export const getCreateCategoryFromSectionsMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategoryFromSections>>, TError,{organizationId: string;projectId: string;data: CreateCategoryFromSectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCategoryFromSections>>, TError,{organizationId: string;projectId: string;data: CreateCategoryFromSectionsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCategoryFromSections>>, {organizationId: string;projectId: string;data: CreateCategoryFromSectionsBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  createCategoryFromSections(organizationId,projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateCategoryFromSectionsMutationResult = NonNullable<Awaited<ReturnType<typeof createCategoryFromSections>>>
    export type CreateCategoryFromSectionsMutationBody = CreateCategoryFromSectionsBody
    export type CreateCategoryFromSectionsMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Creates a new category from existing sections
 */
export const useCreateCategoryFromSections = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategoryFromSections>>, TError,{organizationId: string;projectId: string;data: CreateCategoryFromSectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getCreateCategoryFromSectionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Creates a new category from an existing category
 */
export const createCategoryFromCategory = (
    organizationId: string,
    projectId: string,
    createCategoryFromCategoryBody: CreateCategoryFromCategoryBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateCategoryFromCategory200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/create-from-category`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: createCategoryFromCategoryBody
    },
      options);
    }
  


export const getCreateCategoryFromCategoryMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategoryFromCategory>>, TError,{organizationId: string;projectId: string;data: CreateCategoryFromCategoryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCategoryFromCategory>>, TError,{organizationId: string;projectId: string;data: CreateCategoryFromCategoryBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCategoryFromCategory>>, {organizationId: string;projectId: string;data: CreateCategoryFromCategoryBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  createCategoryFromCategory(organizationId,projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateCategoryFromCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createCategoryFromCategory>>>
    export type CreateCategoryFromCategoryMutationBody = CreateCategoryFromCategoryBody
    export type CreateCategoryFromCategoryMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Creates a new category from an existing category
 */
export const useCreateCategoryFromCategory = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategoryFromCategory>>, TError,{organizationId: string;projectId: string;data: CreateCategoryFromCategoryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getCreateCategoryFromCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a doclist category
 */
export const deleteDoclistCategory = (
    organizationId: string,
    projectId: string,
    categoryId: number,
    deleteDoclistCategoryBody: DeleteDoclistCategoryBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteDoclistCategory200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/${categoryId}`, method: 'delete',
      headers: {'Content-Type': 'application/json', },
      data: deleteDoclistCategoryBody
    },
      options);
    }
  


export const getDeleteDoclistCategoryMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDoclistCategory>>, TError,{organizationId: string;projectId: string;categoryId: number;data: DeleteDoclistCategoryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDoclistCategory>>, TError,{organizationId: string;projectId: string;categoryId: number;data: DeleteDoclistCategoryBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDoclistCategory>>, {organizationId: string;projectId: string;categoryId: number;data: DeleteDoclistCategoryBody}> = (props) => {
          const {organizationId,projectId,categoryId,data} = props ?? {};

          return  deleteDoclistCategory(organizationId,projectId,categoryId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteDoclistCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDoclistCategory>>>
    export type DeleteDoclistCategoryMutationBody = DeleteDoclistCategoryBody
    export type DeleteDoclistCategoryMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Delete a doclist category
 */
export const useDeleteDoclistCategory = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDoclistCategory>>, TError,{organizationId: string;projectId: string;categoryId: number;data: DeleteDoclistCategoryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getDeleteDoclistCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Merge two sections in a chat's doclist
 */
export const mergeChatDoclistSections = (
    organizationId: string,
    projectId: string,
    chatId: string,
    mergeChatDoclistSectionsBody: MergeChatDoclistSectionsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MergeChatDoclistSections200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/merge`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: mergeChatDoclistSectionsBody
    },
      options);
    }
  


export const getMergeChatDoclistSectionsMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeChatDoclistSections>>, TError,{organizationId: string;projectId: string;chatId: string;data: MergeChatDoclistSectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mergeChatDoclistSections>>, TError,{organizationId: string;projectId: string;chatId: string;data: MergeChatDoclistSectionsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergeChatDoclistSections>>, {organizationId: string;projectId: string;chatId: string;data: MergeChatDoclistSectionsBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  mergeChatDoclistSections(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type MergeChatDoclistSectionsMutationResult = NonNullable<Awaited<ReturnType<typeof mergeChatDoclistSections>>>
    export type MergeChatDoclistSectionsMutationBody = MergeChatDoclistSectionsBody
    export type MergeChatDoclistSectionsMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Merge two sections in a chat's doclist
 */
export const useMergeChatDoclistSections = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeChatDoclistSections>>, TError,{organizationId: string;projectId: string;chatId: string;data: MergeChatDoclistSectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getMergeChatDoclistSectionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Merge multiple sections in a chat's doclist
 */
export const mergeSectionsMultiple = (
    organizationId: string,
    projectId: string,
    chatId: string,
    mergeSectionsMultipleBody: MergeSectionsMultipleBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MergeSectionsMultiple200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/merge/multiple`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: mergeSectionsMultipleBody
    },
      options);
    }
  


export const getMergeSectionsMultipleMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeSectionsMultiple>>, TError,{organizationId: string;projectId: string;chatId: string;data: MergeSectionsMultipleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mergeSectionsMultiple>>, TError,{organizationId: string;projectId: string;chatId: string;data: MergeSectionsMultipleBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergeSectionsMultiple>>, {organizationId: string;projectId: string;chatId: string;data: MergeSectionsMultipleBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  mergeSectionsMultiple(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type MergeSectionsMultipleMutationResult = NonNullable<Awaited<ReturnType<typeof mergeSectionsMultiple>>>
    export type MergeSectionsMultipleMutationBody = MergeSectionsMultipleBody
    export type MergeSectionsMultipleMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Merge multiple sections in a chat's doclist
 */
export const useMergeSectionsMultiple = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeSectionsMultiple>>, TError,{organizationId: string;projectId: string;chatId: string;data: MergeSectionsMultipleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getMergeSectionsMultipleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Merge all sections of a category into a section with a new title
 */
export const mergeAllCategorySections = (
    organizationId: string,
    projectId: string,
    chatId: string,
    mergeAllCategorySectionsBody: MergeAllCategorySectionsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MergeAllCategorySections200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/categories/merge-all`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: mergeAllCategorySectionsBody
    },
      options);
    }
  


export const getMergeAllCategorySectionsMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeAllCategorySections>>, TError,{organizationId: string;projectId: string;chatId: string;data: MergeAllCategorySectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mergeAllCategorySections>>, TError,{organizationId: string;projectId: string;chatId: string;data: MergeAllCategorySectionsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergeAllCategorySections>>, {organizationId: string;projectId: string;chatId: string;data: MergeAllCategorySectionsBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  mergeAllCategorySections(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type MergeAllCategorySectionsMutationResult = NonNullable<Awaited<ReturnType<typeof mergeAllCategorySections>>>
    export type MergeAllCategorySectionsMutationBody = MergeAllCategorySectionsBody
    export type MergeAllCategorySectionsMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Merge all sections of a category into a section with a new title
 */
export const useMergeAllCategorySections = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeAllCategorySections>>, TError,{organizationId: string;projectId: string;chatId: string;data: MergeAllCategorySectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getMergeAllCategorySectionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Split a section into two sections
 */
export const splitDoclistSection = (
    organizationId: string,
    projectId: string,
    chatId: string,
    splitDoclistSectionBody: SplitDoclistSectionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SplitDoclistSection200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/split`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: splitDoclistSectionBody
    },
      options);
    }
  


export const getSplitDoclistSectionMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof splitDoclistSection>>, TError,{organizationId: string;projectId: string;chatId: string;data: SplitDoclistSectionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof splitDoclistSection>>, TError,{organizationId: string;projectId: string;chatId: string;data: SplitDoclistSectionBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof splitDoclistSection>>, {organizationId: string;projectId: string;chatId: string;data: SplitDoclistSectionBody}> = (props) => {
          const {organizationId,projectId,chatId,data} = props ?? {};

          return  splitDoclistSection(organizationId,projectId,chatId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type SplitDoclistSectionMutationResult = NonNullable<Awaited<ReturnType<typeof splitDoclistSection>>>
    export type SplitDoclistSectionMutationBody = SplitDoclistSectionBody
    export type SplitDoclistSectionMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Split a section into two sections
 */
export const useSplitDoclistSection = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof splitDoclistSection>>, TError,{organizationId: string;projectId: string;chatId: string;data: SplitDoclistSectionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getSplitDoclistSectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Analyzes sections for similarity using hybrid scoring (embeddings + text + structural analysis). Returns groups of similar sections with progress updates via Server-Sent Events.
 * @summary Analyze section similarity using AI-based duplicate detection
 */
export const analyzeSectionSimilarity = (
    organizationId: string,
    projectId: string,
    analyzeSectionSimilarityBody: AnalyzeSectionSimilarityBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<AnalyzeSectionSimilarity200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/sections/analyze-similarity`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: analyzeSectionSimilarityBody
    },
      options);
    }
  


export const getAnalyzeSectionSimilarityMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeSectionSimilarity>>, TError,{organizationId: string;projectId: string;data: AnalyzeSectionSimilarityBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeSectionSimilarity>>, TError,{organizationId: string;projectId: string;data: AnalyzeSectionSimilarityBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeSectionSimilarity>>, {organizationId: string;projectId: string;data: AnalyzeSectionSimilarityBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  analyzeSectionSimilarity(organizationId,projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type AnalyzeSectionSimilarityMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeSectionSimilarity>>>
    export type AnalyzeSectionSimilarityMutationBody = AnalyzeSectionSimilarityBody
    export type AnalyzeSectionSimilarityMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse

    /**
 * @summary Analyze section similarity using AI-based duplicate detection
 */
export const useAnalyzeSectionSimilarity = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeSectionSimilarity>>, TError,{organizationId: string;projectId: string;data: AnalyzeSectionSimilarityBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getAnalyzeSectionSimilarityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Universal summarization endpoint that generates concise 400-800 word AI-powered summaries using Gemini. Supports pages and sections. Uses Redis caching based on content hash to avoid duplicate AI calls.
 * @summary Generate AI-powered summary for pages and sections
 */
export const getUniversalSummary = (
    organizationId: string,
    projectId: string,
    getUniversalSummaryBody: GetUniversalSummaryBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<GetUniversalSummary200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/summary`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: getUniversalSummaryBody
    },
      options);
    }
  


export const getGetUniversalSummaryMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | GetUniversalSummary404 | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getUniversalSummary>>, TError,{organizationId: string;projectId: string;data: GetUniversalSummaryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getUniversalSummary>>, TError,{organizationId: string;projectId: string;data: GetUniversalSummaryBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getUniversalSummary>>, {organizationId: string;projectId: string;data: GetUniversalSummaryBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  getUniversalSummary(organizationId,projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type GetUniversalSummaryMutationResult = NonNullable<Awaited<ReturnType<typeof getUniversalSummary>>>
    export type GetUniversalSummaryMutationBody = GetUniversalSummaryBody
    export type GetUniversalSummaryMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | GetUniversalSummary404 | InternalServerErrorResponse

    /**
 * @summary Generate AI-powered summary for pages and sections
 */
export const useGetUniversalSummary = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | GetUniversalSummary404 | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getUniversalSummary>>, TError,{organizationId: string;projectId: string;data: GetUniversalSummaryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getGetUniversalSummaryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Sort sections within a category
 */
export const sortCategorySections = (
    organizationId: string,
    projectId: string,
    categoryId: number,
    sortCategorySectionsBody: SortCategorySectionsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SortCategorySections200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/category/${categoryId}/sort`, method: 'patch',
      headers: {'Content-Type': 'application/json', },
      data: sortCategorySectionsBody
    },
      options);
    }
  


export const getSortCategorySectionsMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortCategorySections>>, TError,{organizationId: string;projectId: string;categoryId: number;data: SortCategorySectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sortCategorySections>>, TError,{organizationId: string;projectId: string;categoryId: number;data: SortCategorySectionsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sortCategorySections>>, {organizationId: string;projectId: string;categoryId: number;data: SortCategorySectionsBody}> = (props) => {
          const {organizationId,projectId,categoryId,data} = props ?? {};

          return  sortCategorySections(organizationId,projectId,categoryId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type SortCategorySectionsMutationResult = NonNullable<Awaited<ReturnType<typeof sortCategorySections>>>
    export type SortCategorySectionsMutationBody = SortCategorySectionsBody
    export type SortCategorySectionsMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Sort sections within a category
 */
export const useSortCategorySections = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortCategorySections>>, TError,{organizationId: string;projectId: string;categoryId: number;data: SortCategorySectionsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getSortCategorySectionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    